import { useEffect, useRef } from 'react';
import { getAccessToken } from './apiClient';
import { API_BASE_URL } from './constants';

export interface SseEventData {
  type: string;
  squadraId?: string;
  chiamata?: any;
  title?: string;
  body?: string;
  url?: string;
  timestamp?: number;
}

/**
 * Hook React per la gestione della connessione permanente Server-Sent Events (SSE).
 * Mantiene uno stream aperto verso /api/events/stream per ricezione notifiche ad app in focus.
 */
export function useSseStream(onEvent?: (data: SseEventData) => void) {
  const onEventRef = useRef(onEvent);

  useEffect(() => {
    onEventRef.current = onEvent;
  }, [onEvent]);

  useEffect(() => {
    const token = getAccessToken();
    if (!token) return;

    const streamUrl = `${API_BASE_URL}/events/stream?token=${encodeURIComponent(token)}`;
    const es = new EventSource(streamUrl);

    const handleMessage = (evt: MessageEvent) => {
      try {
        const data: SseEventData = JSON.parse(evt.data);
        if (onEventRef.current) {
          onEventRef.current(data);
        }
      } catch (err) {
        console.warn('[SSE] Errore parse evento:', err);
      }
    };

    es.addEventListener('chiamata_assegnata', handleMessage);
    es.addEventListener('chiamata_creata', handleMessage);
    es.addEventListener('chiamata_modificata', handleMessage);
    es.addEventListener('update', handleMessage);
    es.addEventListener('chiamata_chiusa', handleMessage);
    es.addEventListener('chiamata_rifiutata', handleMessage);
    es.addEventListener('chiamata_sospesa', handleMessage);
    es.addEventListener('chiamata_presa', handleMessage);

    es.onerror = (err) => {
      console.warn('[SSE] Errore stream o disconnessione, riconnessione automatica...', err);
    };

    return () => {
      es.close();
    };
  }, []);
}
